/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import animateIn from "animations/animate-in/animate-in";

import initHeader from "components/header/header";
import heroSlider from "imComponents/hero-slider/hero-slider";
import heroImage from "imComponents/hero-image/hero-image";
import button from "components/buttons/buttons";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import cmsContent from "components/cms-content/cms-content";
import footer from "components/footer/footer";
import contactForm from "components/contact-form/contact-form";
import textImgVar from "imComponents/text-img-var/text-img-var";
import accordion from "imComponents/accordion/accordion";
import cardNews from "components/cards/card-news";
import sliderNews from "components/slider-news/slider-news";
import customQuote from "components/custom-quote/custom-quote";
import titleBox from "components/title-box/title-box";
import galleryList from "components/gallery-list/gallery-list";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import boxImage from "components/box-image/box-image";
import carouselGallery from "imComponents/carousel-gallery/carousel-gallery";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import blockTwoImages from "components/block-two-images/block-two-images";
import cardTextImg from "components/cards/card-text-img";
import sliderTextImg from "components/slider-text-img/slider-text-img";
import cardProduct from "components/cards/card-product";
import archiveList from "components/archive-list/archive-list";
import textIframe from "components/text-iframe/text-iframe";
import textVideo from "components/text-video/text-video";
import timeline from "components/timeline/timeline";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector("body.wp-admin")) {
        initHeader();
        heroSlider();
    }
    accordion();
    galleryList();
    carouselGallery();
    sliderNews();
    blockTwoImages();
    sliderTextImg();
    animateIn();
}
if (document.querySelector("body.wp-admin")) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction("render_block_preview", initBlock);
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
